import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import JwtService from '@/common/jwt.service';
import * as routeConstants from '@/router/constants';
import * as actionTypes from '@/store/actions.type';
import { NOTIFICATION_ERROR } from '@/common/event.types';
import store from '@/store';
import router from '@/router';
import i18n from '@/i18n';

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    this.setHeader();

    Vue.axios.interceptors.response.use(data => {
      return data;
    }, error => {
      if (error.response && error.response.status === 401) {
        store.dispatch(actionTypes.LOGOUT);
        router.push(routeConstants.LOGIN_URL);

        Vue.prototype.$eventHub.$emit(NOTIFICATION_ERROR, {
          message: i18n.t('login.sessionExpiredMsg'),
        });
      }

      return Promise.reject(error.response ? error.response : error);
    });
  },
  setHeader() {
    const jwtToken = JwtService.getToken();

    Vue.axios.defaults.headers = {
      'Access-Control-Allow-Origin': '*',
    };

    if (jwtToken && Vue.axios.defaults.headers) {
      Vue.axios.defaults.headers[
        'Authorization'
        ] = `Bearer ${JwtService.getToken()}`;
    }
  },
  query(resource, params) {
    return Vue.axios.get(resource, {params});
  },
  get(resource, slug = '') {
    return Vue.axios.get(`${resource}/${slug}`);
  },
  post(resource, params) {
    return Vue.axios.post(`${resource}`, params);
  },
  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },
  delete(resource) {
    return Vue.axios.delete(resource);
  },
  patch(resource, params) {
    return Vue.axios.patch(`${resource}`, params);
  },
};

export default ApiService;